import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import AprovacaoFaixaValores from "model/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValores";
import AprovacaoFaixaValoresRotina from "model/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValoresRotina";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnBodyOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import AprovacaoFaixaValoresService from "service/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValoresService";

const aprovacaoFaixaValoresService = new AprovacaoFaixaValoresService();

export default function AprovacaoFaixaValoresCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [aprovacao, setAprovacao] = useState<AprovacaoFaixaValoresRotina>(new AprovacaoFaixaValoresRotina());
    const [titulo, setTitulo] = useState<string>('Aprovação por Faixa de Valores');
    const [editando, setEditando] = useState<boolean>(false);
    const [niveis, setNiveis] = useState<any[]>([]);

    const inputNomeRef = useRef<any>(null);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {

        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }

        aprovacaoFaixaValoresService.niveis().then(data => {
            setNiveis(data);
        }).catch(erro => {
            msgErro("Busca de níveis de aprovação", erro);
        });

    }, [])

    function validar() {

        return true;
    }

    const editorValor = (options: any) => {
        return <InputNumber
            value={options.rowData.valor}
            locale="pt-BR"
            maxFractionDigits={2}
            minFractionDigits={2}
            onChange={(e) => {
                options.rowData['valor'] = e.value;
                let aprovacaoLocal = { ...aprovacao };
                aprovacao.aprovacoes[options.rowIndex] = options.rowData;
                setAprovacao(aprovacaoLocal);
            }}
            inputStyle={{ textAlign: 'right' }}
            style={{ width: '100%', }} />;
    }

    const editorDescricao = (options: any) => {
        return <InputText value={options.rowData.descricao}
            onChange={(e) => {
                options.rowData['descricao'] = e.target.value;
                let aprovacaoLocal = { ...aprovacao };
                aprovacao.aprovacoes[options.rowIndex] = options.rowData;
                setAprovacao(aprovacaoLocal);
            }} style={{ width: '100%' }} maxLength={200}
        />;
    }

    const editorFormula = (options: any) => {
        return <InputText value={options.rowData.formula}
            onChange={(e) => {
                options.rowData['formula'] = e.target.value;
                let aprovacaoLocal = { ...aprovacao };
                aprovacao.aprovacoes[options.rowIndex] = options.rowData;
                setAprovacao(aprovacaoLocal);
            }} style={{ width: '100%' }} maxLength={200}
        />;
    }

    return (

        <BaseCadastro model={aprovacao} service={aprovacaoFaixaValoresService} setModel={(value: AprovacaoFaixaValoresRotina) => setAprovacao(value)} validar={() => validar()} urlService="/aprovacaofaixavalores" pathCadastro="/aprovacaofaixavalores" tituloPagina={'Aprovação por Faixa de Valores'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12">Rotina</Label>
                <div className="col-sm-12">
                    <InputText
                        value={aprovacao.tipoRotina}
                        disabled
                        style={{ width: '100%' }}
                    />
                </div>
            </div>

            <div className="row" style={{ paddingTop: 8 }}>
                <Panel header="Legenda" style={{ width: '200px', paddingLeft: 0 }}>
                    <p style={{ marginBottom: 0 }}>{'+ -> ou'}</p>
                    <span>&nbsp;</span>
                    <p>{'* -> e'}</p>
                </Panel>
                <Panel header="Exemplo Níveis Exigidos" style={{ width: '400px' }}>
                    <p style={{ marginBottom: 0 }}>
                        {`(((3 ou 4) e (5 e 6)) ou 1)`}
                    </p>
                    <span>=</span>
                    <p>
                        {`(((3 + 4) * (5 * 6)) + 1)`}
                    </p>
                </Panel>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Faixas de valores"
                        getNewModel={() => new AprovacaoFaixaValores()}
                        dataKey="key"
                        lista={aprovacao.aprovacoes ? aprovacao.aprovacoes : []}
                        setLista={(value: any) => setAprovacao({ ...aprovacao, aprovacoes: value })}
                        scrollable
                        scrollHeight='500px'
                    >
                        <Column field="valor" header="Valor até" style={{ textAlign: 'right' }}
                            body={(rowData) => {
                                return <span style={{ fontSize: 'inherit', color: '#000' }}>
                                    {new Intl.NumberFormat('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(rowData.valor)}
                                </span>
                            }}
                            editor={editorValor} />
                        <Column field="descricao" header="Descrição" editor={editorDescricao} />
                        <Column field="formula" header="Níveis exigidos" editor={editorFormula} />
                        <Column field="ativo" header="Ativo"
                            body={(rowData, options: ColumnBodyOptions) =>
                                <Checkbox disabled checked={rowData.ativo} />
                            }
                            editor={(options) => {
                                return <Checkbox checked={options.rowData.ativo}
                                    onChange={(e) => {
                                        options.rowData.ativo = e.checked;

                                        let aprovacaoLocal = { ...aprovacao };
                                        aprovacao.aprovacoes[options.rowIndex] = options.rowData;
                                        setAprovacao(aprovacaoLocal);
                                    }}
                                />
                            }}
                        />
                    </BaseDataTableEdit>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">

                    <DataTable value={niveis} header='Consulta de níveis de aprovação' emptyMessage="Nenhum registro encontrado">
                        <Column field="codigo" header="Código" />
                        <Column field="nome" header="Descrição" />
                    </DataTable>


                </div>
            </div>

        </BaseCadastro>
    )
}